import VueRouter from 'vue-router'
import store from '../vuex/store.js'
import axios from 'axios'
import * as dateutils from '../DateTimeUtils'

let routes = [
    // {
    //     path: '/',
    //     name: 'home',
    //     component: require('../pages/Home').default,
    // },
    {
        path: '/',
        name: 'myAppointments',
        component: require('../pages/MyAppointments').default,
    },
    {
        path: '/patients-authentication',
        name: 'patientAuthentication',
        component: require('../pages/helpers/Middleware').default,
        meta: {
            requireLogin: false,
            loggedInRedirect: '/'
        }
    },
    {
        path: '/appointment-call/:appointmentId',
        name: 'appointmentCall',
        component: require('../pages/VideoCall').default,
        meta: {
            requireLogin: true,
            loggedInRedirect: '/'
        }
    },
    // {
    //     path: '/my-appointments',
    //     name: 'myAppointments',
    //     component: require('../pages/MyAppointments').default,
    // },
    {
        path: '/my-appointments/:appointmentId',
        name: 'myAppointments',
        component: require('../pages/MyAppointments').default,
    },
    {
        path: '/my-profile',
        name: 'myProfile',
        component: require('../pages/MyProfile').default,
    },
    {
        path: '/update-profile',
        name: 'updateProfile',
        component: require('../pages/UpdateProfile').default,
    },
    {
        path: '/my-medical-records',
        name: 'myMedicalRecords',
        component: require('../pages/MyMedicalRecords').default,
    },
    {
        path: '/my-medical-records/:id',
        name: 'myMedicalRecordsDetails',
        component: require('../pages/MyMedicalRecords').default,
    },
    {
        path: '/my-questions',
        name: 'myQuestions',
        component: require('../pages/MyQuestions').default,
    },
    {
        path: '/my-questions/:id',
        name: 'myQuestionDetail',
        component: require('../pages/MyQuestions').default,
    },
];

let router = new VueRouter({
    mode: 'history',
    routes
})

router.beforeEach(
    (to, from, next) => {
        let accessToken = store.getters.accessToken ? store.getters.accessToken : localStorage.getItem('accessToken')
        // let userInfo = JSON.parse(localStorage.getItem('userInfo'))
        if (!store.getters.accessToken) {
            let loginObject = {
                accessToken: accessToken,
                userId: localStorage.getItem('userId'),
                userType: localStorage.getItem('userType'),
                userInfo: JSON.parse(localStorage.getItem('userInfo')),
                registration: JSON.parse(localStorage.getItem('registration')),
                education: JSON.parse(localStorage.getItem('education')),
                mobile: localStorage.getItem('mobile'),
                timezone:localStorage.getItem('timezone')
            }
            store.dispatch('setUserState', loginObject)
            axios.defaults.headers.common['Authorization'] = 'Bearer ' + store.getters.accessToken
            dateutils.setTimezone(loginObject.timezone)
        }
        next()
    }
)

export default router